<arm-layout [menuTitle]="title">
  <div menu class="arm-side-nav">
    <mat-nav-list [disableRipple]="true">
      <a mat-list-item *ngFor="let item of items;" [routerLink]="item.routerLink" routerLinkActive="active">
        <div class="item">{{item.name}}</div>
      </a>
    </mat-nav-list>
  </div>
  <div main class="container">
    <router-outlet></router-outlet>
  </div>
</arm-layout>
